import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CappieReporterService } from '@mode/shared/util-cappie-reporter';
import { extractScripts } from '@mode/shared/util-js';

@Directive({
  selector: '[modeNotebookCellHtml]',
})
export class NotebookCellHtmlDirective implements OnInit {
  @Input() modeNotebookCellHtml = '';
  constructor(
    private el: ElementRef,
    private domSanitizer: DomSanitizer,
    private cappieReporterService: CappieReporterService
  ) {}
  ngOnInit() {
    if (this.modeNotebookCellHtml) {
      const reporter = this.cappieReporterService.progressEventAPI('notebook-html-reporter');
      // when word-wrapping table cells, don't insert line breaks into the middle of ISO 8601-style dates.
      // Blindly regex-munging cell output HTML *seems* like a bad idea but this is hopefully carefully
      // circumscribed to in practice have no ill effects, and fixes a really ugly, really common case
      //   https://mode.slack.com/archives/C0RHQ90SX/p1523307759000507?thread_ts=1523306641.000090&cid=C0RHQ90SX
      const content =
        `<div>${
          this.modeNotebookCellHtml &&
          this.modeNotebookCellHtml.replace(
            /<td>(\d\d\d\d-\d\d-\d\d)\b/g,
            '<td><span style="white-space: nowrap">$1</span>'
          )
        }</div>` +
        // Attempt to call HTMLWidgets.staticRender() if available. This is necessary for
        // R plotly graphs because normally staticRender() is fired one time only after DOMContentLoaded.
        // Since this code will likely be executing after that, we have to manually call it.
        // Debounced since there can be many plotly graphs in a single report and no need to waste
        // cycles calling it multiple times.
        `<script>
          if (window.HTMLWidgets && window.HTMLWidgets.staticRender) {
            clearTimeout(window.staticRenderDebounce);
            window.staticRenderDebounce = setTimeout(function() {
              window.HTMLWidgets.staticRender();
            }, 500);
          }
        </script>`;
      reporter.start('starting notebook HTML snippet');
      const { fragment, load } = extractScripts(content, window.document.head);
      this.el.nativeElement.append(fragment);
      load().then(() => reporter.end('finished notebook HTML snippet'));
    }
  }
}
